export const FETCH_SUGGESTED_DOMAINS_REQUEST = 'FETCH_SUGGESTED_DOMAINS_REQUEST';
export const FETCH_SUGGESTED_DOMAINS_SUCCESS = 'FETCH_SUGGESTED_DOMAINS_SUCCESS';
export const FETCH_SUGGESTED_DOMAINS_FAILURE = 'FETCH_SUGGESTED_DOMAINS_FAILURE';

export const FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_SUCCESS = 'FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_SUCCESS';
export const FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_REQUEST = 'FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_REQUEST';
export const FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_FAILURE = 'FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_FAILURE';

export const UPDATE_SUGGESTED_DOMAINS_REQUEST = 'UPDATE_SUGGESTED_DOMAINS_REQUEST';
export const UPDATE_SUGGESTED_DOMAINS_SUCCESS = 'UPDATE_SUGGESTED_DOMAINS_SUCCESS';
export const UPDATE_SUGGESTED_DOMAINS_PARTIAL_SUCCESS = 'UPDATE_SUGGESTED_DOMAINS_PARTIAL_SUCCESS';
export const UPDATE_SUGGESTED_DOMAINS_FAILURE = 'UPDATE_SUGGESTED_DOMAINS_FAILURE';
